import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useBrandingColors } from '../../hooks/useBrandingColors';

export function SidebarActions() {
  const colors = useBrandingColors();
  const navigate = useNavigate();

  const handleCreateVacancy = () => {
    navigate('/recruiter/vacancy/create');
  };

  return (
    <div className="px-2.5 pb-4">
      <button
        data-testid="sidebar-new-vacancy"
        className="w-full text-white rounded-lg py-2.5 px-2.5 flex items-center gap-2 text-[14px] font-medium transition-colors"
        style={{ backgroundColor: colors.primary }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = colors.primaryHover;
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = colors.primary;
        }}
        onClick={handleCreateVacancy}
      >
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M8 3V13M3 8H13" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
        Новая вакансия
      </button>
    </div>
  );
}
